// @flow
import makeSettingsReducer from 'app/common/reducers/settings/makeSettingsReducer';

import config from 'app/config';


export const vendingDishesDataKey: 'vendingDishes' = 'vendingDishes';

export type ColumnVisibilityVendingDishes = {
  photo: boolean,
  portion: boolean,
  cost: boolean,
  type: boolean,
  category: boolean,
  options: boolean,
}

export const defaultColumnVisibilityVendingDishes: ColumnVisibilityVendingDishes = {
  photo: true,
  portion: true,
  cost: true,
  type: true,
  category: true,
  options: true,
};

export type Settings = {
  rows: number,
  ...ColumnVisibilityVendingDishes,
}

export const vendingDefaultState: Settings = {
  rows: config.perPageItems,
  ...defaultColumnVisibilityVendingDishes,
};

export default makeSettingsReducer(vendingDishesDataKey, vendingDefaultState);
